import { Component, EventEmitter, Inject, OnInit, Output, ViewEncapsulation} from '@angular/core';
import { FormBuilder, FormControl, FormGroup,  Validators } from '@angular/forms';
// Material Imports
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
//Interfaces
import { DialogData } from '@app/shared/models/custom-dialog.model';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
import { RFID_TAG_LENGTH, rfidTagValidators } from '@app/shared/utils/rfid';
@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  selector: 'app-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CustomDialogComponent implements OnInit {
  form!: FormGroup;

  @Output() actionClicked = new EventEmitter<string>();

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CustomDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  /** Las etiquetas RFID siempre indican su longitud fija (24 caracteres). */
  fieldLabel(field: any): string {
    const label = String(field?.label ?? '');
    if (field?.type !== 'rfid' || /24\s*caracteres/i.test(label)) return label;
    return `${label} (${RFID_TAG_LENGTH} caracteres)`;
  }

  ngOnInit(): void {
    const group: any = {};

    this.data.fields.forEach(field => {
      if (field.type !== 'table' && field.type !== 'button') { //Si no es tabla ni botón
        const validators: any[] = field.required ? [Validators.required] : []; //Ver si es un campo requerido
        if (field.type === 'rfid') validators.push(...rfidTagValidators());
        let initialValue = field.value !== undefined ? field.value : ''; //Ver si se mando un valor
        if (field.type === 'multiselect' && !initialValue) initialValue = []; //Si es un multiselect, el valor es un array
        group[field.key] = [initialValue, validators];
      }
    });

    this.form = this.fb.group(group);

    this.setupDependencies();
  }

  //--------------------------------------------------------------------------------------------------------------
  //Use Case actions
  //--> Multiselect
  /*** @description Validar si todos los elementos están seleccionados*/
  isAllCheck(field: any): boolean {
    let control = this.form.get(field.key);
    if (!control || !field.options) return false;
    let selectedValues = control.value || [];
    return selectedValues.length === field.options.length;
  }
  /*** @description Validar si algunos están seleccionados*/
  isSomeChecked(field: any): boolean {
    const control = this.form.get(field.key);
    if (!control || !field.options) return false;
    const selectedValues = control.value || [];
    return selectedValues.length > 0 && selectedValues.length < field.options.length;
  }
  /*** @description Seleccionar todos*/
  CheckAll(field: any): void {
    const control = this.form.get(field.key);
    if (!control || !field.options) return;
    if (this.isAllCheck(field)) { // Si ya está seleccionado, quitar todo
      control.setValue([]);
    } else { //Seleccionar todo
      const allValues = field.options.map((opt: any) => opt.value);
      control.setValue(allValues);
    }
  }

  //Inputs padre e hijo
  private setupDependencies(): void {
    this.data.fields.forEach(field => {
      
      if (field.dependsOn && field.optionsMap) {// Si tiene 'dependsOn' y un 'optionsMap', es un input que depende de otro
        const parentControl = this.form.get(field.dependsOn);
        const childControl = this.form.get(field.key);

        if (parentControl && childControl) {
          parentControl.valueChanges.subscribe(parentValue => { //Escuchar los cambios del padre
            field.options = field.optionsMap![parentValue] || []; // Actualizar el hijo según lo que se eligi
            childControl.setValue(null); //Resetear el hijo por si cambió el padre
            if (!parentValue) childControl.disable(); //Si no hay padre, deshabilitar el hijo
            else childControl.enable();
          });

          if (parentControl.value) { // Si el padre ya venía con un valor
            field.options = field.optionsMap[parentControl.value] || [];
          } else {
            field.options = [];
            childControl.disable();
          }
          
        }
      }
    });
  }

  //Imprimir correctamente el valor seleccionado en autocomlete
  fixAutocomplete(options: any[]){
    console.log('[fixAutocomplete] options', options)
    return (value: any): string =>
    options?.find(o => o.value === value)?.label || '';
  }

  //--------------------------------------------------------------------------------------------------------------
  //Dialog actions
  /*** @description Si se hizo click en alguno de los botones */
  onActionClick(content?: string) {
    if(content) this.actionClicked.emit(content); // boton picado
  }

  onSave(): void {
  if (this.form.valid) {
    const formValue = { ...this.form.value };

    // Transformar fechas específicas
    this.data.fields.forEach(field => {
      if (field.type === 'date' && field.key === 'expiration') {
        const value = formValue[field.key];

        if (value) {
          const date = new Date(value);

          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();

          formValue[field.key] = `${year}-${month}-${day}`;
        }
      }
    });

    this.dialogRef.close(formValue);
  }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}